import React, { useContext } from 'react';
import { Icon } from '@ellucian/ds-icons/lib';
import GlobalLocaleContext from '../../GlobalLocale/GlobalLocaleContext';

const BackArrow = props => {
    const { localeDirection } = useContext(GlobalLocaleContext);
   
    return (
        <Icon name={localeDirection === 'rtl' ? 'arrow-right' : 'arrow-left'}  {...props}/>
    );
};

export default BackArrow;
